import React from "react";

import Header from "./Header";
import StatsCard from "./StatsCard";
import GenderDistribution from "./GenderDistribution";
import CountryDistribution from "./CountryDistribution";
import MonthlyGrowth from "./MonthlyGrowth";
import ProfilesTable from "./ProfilesTable";

const profiles = [];

function Traveller() {
  return (
    <div className="min-h-screen bg-gray-100 md:p-8 p-4">
      <div className="p-4">
        <div className="grid md:grid-cols-2 gap-4 w-full">
          <div className="w-full">
            <Header />
          </div>
          <div className=" w-full ">
            <StatsCard />
          </div>
        </div>

        <div className="bg-white rounded-[1.75rem] w-full shadow p-6 mb-8 mt-10">
          <h1 className=" mb-6 font-['Roboto_Mono'] text-2xl font-bold ">
            Traveler Trends & Analytics
          </h1>
          <div className="grid md:grid-cols-7 grid-cols-1 md:gap-4 gap-y-4">
            <div className="col-span-2 font-quicksand text-[14px] font-medium text-black">
              <GenderDistribution />
            </div>
            <div className="col-span-3 font-quicksand text-[14px] font-medium text-black">
              <CountryDistribution />
            </div>
            <div className="col-span-2">
              <MonthlyGrowth />
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1">
          <ProfilesTable profiles={profiles} />
        </div>
      </div>
    </div>
  );
}

export default Traveller;
